import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchIngredients = createAsyncThunk(
  "ingredients/fetchIngredients",
  async () => {
    const response = await axios.get(`${BASE_URL}/api/ingredients`);
    return response.data;
  }
);

const ingredientSlice = createSlice({
  name: "ingredients",
  initialState: {
    ingredients: [],
    isLoadingIngredients: false,
    error: null,
  },
  reducers: {
    clearIngredients: (state) => {
      state.ingredients = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch ingredients
      .addCase(fetchIngredients.pending, (state) => {
        state.isLoadingIngredients = true;
        state.error = null;
      })
      .addCase(fetchIngredients.fulfilled, (state, action) => {
        state.ingredients = action.payload;
        state.isLoadingIngredients = false;
      })
      .addCase(fetchIngredients.rejected, (state, action) => {
        state.isLoadingIngredients = false;
        state.error = action.error.message;
      });
  },
});

export const { clearIngredients } = ingredientSlice.actions;

export default ingredientSlice.reducer;
